import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';

export const WPEPreview = ({ element, editmode, Icon, onDelete }) => {
  return (
    <Box
      className="flex items-center justify-between group"
      sx={{ position: 'relative' }}
    >
      <Box className="flex items-center gap-2">
        <Icon />
        <Typography>{element.name}</Typography>
      </Box>

      {editmode && (
        <IconButton
          size="small"
          className="no-nav opacity-0 group-hover:opacity-100 transition-opacity"
          onClick={() => onDelete(element)}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};
